
export default class Carousel {

	static getHolderSelectors = () => ['.carousel-element'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		let self = this;
		let lastWindowSize = window.innerWidth;

		this.#setSplide();

		window.addEventListener('resize', function(event) {
			if ((lastWindowSize < 768 && window.innerWidth >= 768) || (lastWindowSize >= 768 && window.innerWidth < 768)) {
				lastWindowSize = window.innerWidth;
				self.#setSplide();
			}
		}, true);
	}

	#setSplide() {
		if (window.innerWidth >= 768) {
			new Splide(this.#holderElement.querySelector('.splide'), {
				type: 'loop',
				perPage: 3,
				perMove: 1,
				gap: '1rem',
				pagination: false,
				arrows: true,
			}).mount();
		} else {
			new Splide(this.#holderElement.querySelector('.splide'), {
				type: 'loop',
				perPage: 1,
				perMove: 1,
				gap: '1rem',
				pagination: false,
				arrows: true,
			}).mount();
		}
	}

}
